// [hints][diag] ловим повторную загрузку подсказок набора после ввода или стирания символа.
// Обычный режим пишет только аномалии. Подробный включается ключом mosta-diag=hints
// в localStorage и пишет ещё начало и конец каждой загрузки.
// Каждая запись одна строка из пар ключ=значение, потому что объект в консоли
// пользователя остаётся свёрнутым, а при копировании превращается в Object

type DiagValue = string | number | boolean | null | undefined;

const TAG = "[hints][diag]";
const MAX_TEXT = 40;
const REPEAT_WINDOW_MS = 3000;
const REMOUNT_WINDOW_MS = 2000;

let seq = 0;

function formatValue(value: DiagValue): string {
  if (typeof value === "string") {
    return JSON.stringify(value.length > MAX_TEXT ? value.slice(0, MAX_TEXT) + "…" : value);
  }
  if (typeof value === "boolean") return value ? "1" : "0";
  if (typeof value === "number") return String(Math.round(value));
  return String(value);
}

export function hintsDiag(event: string, fields: Record<string, DiagValue>): void {
  const pairs = Object.entries(fields).map(([key, value]) => `${key}=${formatValue(value)}`);
  console.log(`${TAG} ${event} ${pairs.join(" ")}`);
}

export function hintsDiagVerbose(): boolean {
  try {
    return localStorage.getItem("mosta-diag") === "hints";
  } catch {
    return false;
  }
}

interface LastRequest {
  filter: string;
  container: string;
  at: number;
}

// Последняя первая страница по типу и id набора
const lastRequests = new Map<string, LastRequest>();

export interface HintsRequest {
  type: number;
  id: number | undefined;
  filter: string;
  offset: number;
  seq: number;
  startedAt: number;
}

// container приходит строкой, по ней видно, сменился ли он между двумя запросами с одним текстом
export function hintsRequestStarted(
  type: number,
  id: number | undefined,
  filter: string,
  container: string,
  offset: number
): HintsRequest {
  const request = { type, id, filter, offset, seq: ++seq, startedAt: performance.now() };
  if (offset === 0) {
    const key = `${type}:${id}`;
    const prev = lastRequests.get(key);
    const sinceMs = prev ? request.startedAt - prev.at : Infinity;
    if (prev && prev.filter === filter && sinceMs < REPEAT_WINDOW_MS) {
      hintsDiag("repeat", {
        type,
        setId: id,
        filter,
        sinceMs,
        containerChanged: prev.container !== container,
        seq: request.seq,
      });
    }
    lastRequests.set(key, { filter, container, at: request.startedAt });
  }
  if (hintsDiagVerbose()) {
    hintsDiag("load", { type, setId: id, filter, offset, seq: request.seq });
  }
  return request;
}

export function hintsRequestDone(request: HintsRequest, count: number): void {
  if (!hintsDiagVerbose()) return;
  hintsDiag("done", {
    type: request.type,
    setId: request.id,
    filter: request.filter,
    offset: request.offset,
    count,
    ms: performance.now() - request.startedAt,
    seq: request.seq,
  });
}

// Время размонтирования селектора по типу и id набора
const unmountedAt = new Map<string, number>();

export function hintsSelectorUnmounted(type: number, id: number | undefined): void {
  unmountedAt.set(`${type}:${id}`, performance.now());
}

// Тот же селектор смонтирован вскоре после размонтирования, значит список пересоздан, а не отфильтрован
export function hintsSelectorMounted(type: number, id: number | undefined): void {
  const key = `${type}:${id}`;
  const at = unmountedAt.get(key);
  unmountedAt.delete(key);
  if (at === undefined) return;
  const sinceMs = performance.now() - at;
  if (sinceMs < REMOUNT_WINDOW_MS) {
    hintsDiag("remount", { type, setId: id, sinceMs });
  }
}
